/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
export default {
  props: {
    addressItem: {
      type: Object,
      "default": function _default() {
        return {
          hot: true
        };
      }
    }
  },
  components: {},
  computed: {
    fullAddress: function fullAddress() {
      var addressItem = this.addressItem;

      if (!addressItem.fullAddress) {
        var f = '';

        if (addressItem.provinceName) {
          f += addressItem.provinceName;
        }

        if (addressItem.cityName) {
          f += addressItem.cityName;
        }

        if (addressItem.districtName) {
          f += addressItem.districtName;
        }

        if (addressItem.detailAddress) {
          f += addressItem.detailAddress;
        }

        return f;
      } else {
        return addressItem.fullAddress;
      }
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {}
};